module.exports = __webpack_public_path__ + "static/media/left-bg.53a98d2e.png";